import React, {FC, useCallback, useEffect, useRef, useState} from 'react';
import {
    IAssessmentProject,
    ICommentThread,
    IDam,
    IFailureMode,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import {get, post} from "../fetchers/fetchers";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import DialogContentText from '@material-ui/core/DialogContentText';

import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    TableRow,
    TextField, TextFieldProps,
    Tooltip,
    withStyles
} from "@material-ui/core";
import Assessment from "./assessment";
import {useParams} from "react-router";
 
import ProjectFailureModes from "./project_failure_modes";
import Documents from "./documents";
import { API_URL } from "../env";
interface IProjectSettingsProps {
    closeDialogCallback: (reload: boolean) => void;
}

interface IRouteParams {
    id: string
}



const ProjectSettings: FC<IProjectSettingsProps> = ({
                                                        closeDialogCallback
                                                    }) => {


    const params = useParams<IRouteParams>()

    const [newFailureModes, setNewFailureModes] = useState<IFailureMode[]>([]);

    const setFailureModes = useCallback((failureModes: IFailureMode[]) => {
        setNewFailureModes(failureModes)

    }, [setNewFailureModes]);

    const  addProjectFailureModes = async() => {

        for (let i = 0; i < newFailureModes.length; i++) {
            if (newFailureModes[i].selected && !newFailureModes[i].existing ) {
                await post<IProjectFailureMode>( API_URL + "failure_modes/" + params.id, {failure_mode_id: newFailureModes[i].uuid});
            }
        }

    }

    const updateFailureModes = () => {
        addProjectFailureModes().then(
            () => {
                closeDialogCallback(true)
            }
        )
    }


    return (

        <Dialog open={true} onClose={closeDialogCallback} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Settings</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography>
                        Group Failure Modes
                    </Typography>
                    <p>
                        <ProjectFailureModes updateSelectedFailureModes={setFailureModes} assessment_id={parseInt(params.id)}/>
                    </p>


                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={_=>closeDialogCallback(false)} color="primary">
                    Cancel
                </Button>
                <Button onClick={updateFailureModes} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProjectSettings;

